// Components
import { Stack } from "@mui/material";
import { MBSChip } from "../../Common/MBSChip";

// Naming convention for patient table
export const getPatientTableRowId = (patient) =>
  `${patient?.inSystem ? "inSystem" : "guest"}-${patient?.id}`;

// Sorting function to sort patients by last name, then first name, then source (in system before guest)
export const sortPatientTableRows = (patients = []) => {
  const getSortableValue = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();

  const getSourceSortValue = (patient) =>
    patient?.inSystem ? "a-insystem" : "b-guest";

  return [...patients].sort((leftPatient, rightPatient) => {
    const lastNameComparison = getSortableValue(
      leftPatient?.lastName
    ).localeCompare(getSortableValue(rightPatient?.lastName));

    if (lastNameComparison !== 0) {
      return lastNameComparison;
    }

    const firstNameComparison = getSortableValue(
      leftPatient?.firstName
    ).localeCompare(getSortableValue(rightPatient?.firstName));

    if (firstNameComparison !== 0) {
      return firstNameComparison;
    }

    return getSourceSortValue(leftPatient).localeCompare(
      getSourceSortValue(rightPatient)
    );
  });
};

// Function to get the patient table columns
export const getPatientTableColumns = (t) => [
  {
    field: "firstName",
    headerName: t("patientForm.firstNameLabel"),
    flex: 1,
    minWidth: 125,
  },
  {
    field: "lastName",
    headerName: t("patientForm.lastNameLabel"),
    flex: 1,
    minWidth: 125,
  },
  {
    field: "healthCardNumber",
    headerName: t("common.patientInfo.healthCardNumber"),
    minWidth: 150,
  },
  {
    field: "dob",
    headerName: t("patientForm.dobLabel"),
    minWidth: 125,
  },
  {
    field: "userEmail",
    headerName: t("mbsSearch.table.mediNavAccount"),
    flex: 1,
    minWidth: 175,
    valueGetter: (_, row) => {
      const normalizedEmail = (row.userEmail || "").trim();
      return normalizedEmail || "-";
    },
  },
  {
    field: "source",
    headerName: t("mbsSearch.table.source"),
    minWidth: 110,
    valueGetter: (_, row) =>
      t(
        row.inSystem
          ? "mbsSearch.table.sourceInSystem"
          : "mbsSearch.table.sourceGuest"
      ),
    renderCell: ({ row }) => {
      return (
        <Stack alignItems="center" height="100%">
          <MBSChip inSystem={row.inSystem} sx={{ width: "100%" }} />
        </Stack>
      );
    },
  },
  {
    field: "address",
    headerName: t("patientForm.addressLabel"),
    minWidth: 180,
  },
  {
    field: "postalCode",
    headerName: t("patientForm.postalCodeLabel"),
    minWidth: 130,
  },
  {
    field: "city",
    headerName: t("patientForm.cityLabel"),
    minWidth: 130,
  },
  {
    field: "province",
    headerName: t("patientForm.provinceLabel"),
    minWidth: 110,
  },
  {
    field: "primaryPhone",
    headerName: t("patientForm.phoneNumberLabel"),
    minWidth: 160,
  },
  {
    field: "secondaryPhone",
    headerName: t("patientForm.secondaryPhoneNumberLabel"),
    minWidth: 170,
  },
  {
    field: "email",
    headerName: t("patientForm.emailLabel"),
    minWidth: 220,
  },
  {
    field: "registrationNumber",
    headerName: t("patientForm.registrationNumberLabel"),
    minWidth: 170,
  },
  {
    field: "healthCardProvince",
    headerName: t("patientForm.healthCardProvinceLabel"),
    minWidth: 180,
  },
];
